require('./brokerMyInvestmentsProducts.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const Immutable = require('immutable');

// @commons
const { OKLink } = require('commonsComponents/OKLink');

// @components
const BrokerMyInvestmentsProductsOthers = require('../brokerMyInvestmentsOthersTable/brokerMyInvestmentsOthersTable');
const BrokerMyInvestmentsStocksTable = require('../brokerMyInvestmentsStocksTable/brokerMyInvestmentsStocksTable');
const BrokerMyInvestmentsFundsTable = require('../brokerMyInvestmentsFundsTable/brokerMyInvestmentsFundsTable');
const { BrokerMyInvestmentsWrappedProductsTable } = require('../brokerMyInvestmentsWrappedProductsTable/brokerMyInvestmentsWrappedProductsTable');
const BrokerMyInvestmentsProductsEmptyStates = require('../brokerMyInvestmentsProductsEmptyStates/brokerMyInvestmentsProductsEmptyStates');
const BrokerMyInvestmentsFooter = require('../brokerMyInvestmentsFooter/brokerMyInvestmentsFooter');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;
const { taggingEventHandled } = require('utilities/taggingEventHandled');

// @hocs
import withFeatureToggling from 'hocs/withFeatureToggling/withFeatureToggling';

// @constants
const {
    TYPE_STOCKS,
    TYPE_PLANS,
    TYPE_WARRANTS,
    TYPE_FUNDS,
    TYPE_ETFS,
    TYPE_OTHERS,
    BROKER_CORPORATE_OPERATIONS_URL,
    MYPROFILE_BROKER_EXPLORE_URL,
    TYPE_ALTERNATIVE_FUNDS_PG,
    ALTERNATIVE_FUNDS,
    ALTERNATIVE_FUNDS_INPUT_VALUE
} = require('constants/index');
const { SHOW_GLOBAL_POSITION_VENTURE_CAPITAL_FUNDS } = require('constants/flagBasedFeatures');

const { INVESTMENT_PRODUCTS_LIST, TYPE_ALTERNATIVE_FUNDS } = require('constants/flagBasedFeatures');

class BrokerMyInvestmentsProducts extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showCompleteList: {
                [TYPE_STOCKS]: false,
                [TYPE_WARRANTS]: false,
                [TYPE_ETFS]: false,
                [TYPE_PLANS]: false,
                [TYPE_FUNDS]: false,
                [TYPE_ALTERNATIVE_FUNDS_PG]: false,
                [TYPE_OTHERS]: false
            }
        };

        this.handleSeeAllLinkClick = this.handleSeeAllLinkClick.bind(this);
        this.redirectToSearch = this.redirectToSearch.bind(this);
    }

    getCurrency() {
        const { immStocksByType } = this.props;
        return immStocksByType.entries().next().value[1].get('currency');
    }

    buildExcludedItemLabel(type, excludedItemsNumber) {
        switch (type) {
            case TYPE_ALTERNATIVE_FUNDS_PG:
                return formatText(`broker-myInvestments${type}ExcludedItems`, [
                    excludedItemsNumber
                ]);
            case TYPE_STOCKS:
                return formatText(`broker-myInvestments${type}ExcludedItems`, [
                    excludedItemsNumber
                ]);
            case TYPE_WARRANTS:
                return formatText(`broker-myInvestments${type}ExcludedItems`, [
                    excludedItemsNumber
                ]);
            case TYPE_ETFS:
                return formatText(`broker-myInvestments${type}ExcludedItems`, [
                    excludedItemsNumber
                ]);
            case TYPE_FUNDS:
                return formatText(`broker-myInvestments${type}ExcludedItems`, [
                    excludedItemsNumber
                ]);
            case TYPE_PLANS:
                return formatText(`broker-myInvestments${type}ExcludedItems`, [
                    excludedItemsNumber
                ]);
            case TYPE_OTHERS:
                return formatText(`broker-myInvestments${type}ExcludedItems`, [excludedItemsNumber]);
        }
    }

    buildOthersTable() {
        const others = this.props.immStocksByType.get('others');

        if (this.props.displayOthers && others && !others.get('stocks').isEmpty()) {
            return this.wrapProductTable(TYPE_OTHERS, others);
        }
    }

    redirectToSearch(typeProduct) {
        const type = typeProduct === TYPE_ALTERNATIVE_FUNDS_PG ? ALTERNATIVE_FUNDS_INPUT_VALUE : typeProduct
        this.props.resetSpecificProduct(type)
    }


    buildSearchLink(type) {
        const linkText = formatText(`broker-${type}LinkText`);
        return (
            <OKLink
                to={MYPROFILE_BROKER_EXPLORE_URL}
                onClick={() => {
                    taggingEventHandled(this.props.pageName, 'searchLink', type);
                    this.redirectToSearch(type.toUpperCase())
                }}>
                {linkText}
            </OKLink>
        );
    }

    buildSeeAllLink(type, productList) {
        if (this.state.showCompleteList[type] || productList.size <= 5) {
            return;
        }
        const handler = () => {
            taggingEventHandled(this.props.pageName, 'seeAllLink', type);
            this.handleSeeAllLinkClick(type);
        };
        let seeAllText;
        switch (type) {
            case TYPE_ALTERNATIVE_FUNDS_PG:
                seeAllText = 'broker-seeAllAlternativeFunds'
                break;
            case TYPE_STOCKS:
                seeAllText = 'broker-seeAllStocks'
                break;
            case TYPE_PLANS:
                seeAllText = 'broker-seeAllPlans'
                break;
            case TYPE_WARRANTS:
                seeAllText = 'broker-seeAllWarrants'
                break;
            case TYPE_FUNDS:
                seeAllText = 'broker-seeAllFunds'
                break;
            case TYPE_ETFS:
                seeAllText = 'broker-seeAllEtfs'
                break;
            default:
                seeAllText = 'broker-seeAll'
                break;
        }
        return (
            <span className="broker-my-investments-tables__see-all-link-container broker-my-investments-tables__see-all-link-container--left">
                <OKLink modifier="widget" inverse={true} onClick={handler}>
                    <FormattedText value={seeAllText} />
                </OKLink>
            </span>
        );
    }

    handleSeeAllLinkClick(type) {
        this.setState(function (prevState) {
            return {
                showCompleteList: Object.assign({}, prevState.showCompleteList, { [type]: true })
            };
        });
    }

    wrapProductTable(type, products) {
        if (!products || !products.get('stocks') || products.get('stocks').size === 0) {
            return (
                <BrokerMyInvestmentsProductsEmptyStates
                    productType={type}
                    immMyWalletCharts={this.props.immMyWalletCharts}
                    onOpenTraderClick={this.props.onOpenTraderClick}
                    setOrdersAndMovementsAccessFrom={this.props.setOrdersAndMovementsAccessFrom}
                    resetSpecificProduct={this.props.resetSpecificProduct}
                    pageName={this.props.pageName}
                >
                </BrokerMyInvestmentsProductsEmptyStates>
            );
        }

        const { alternativeValueColumnTitle, onOpenTraderClick, immFundsContributionsList } = this.props;
        const title = formatText(`broker-investments${type}TableTitle`);
        const itemsNumber = products.get('stocks').size;
        const excludedItemsNumber = products.get('totalExcludedItems');
        const hasExcludedItems = products.get('hasExcludedItems');
        const earnings = products.get('earnings');
        const earningsPercentage = products.get('profitablePercentage');
        const currency = products.get('currency');
        const totalValue = products.get('totalValue');
        const productList = products.get('stocks');
        const capital = products.get('totalInvestment');

        const searchLink = this.buildSearchLink(type);
        const seeAllLink = this.buildSeeAllLink(type, productList);
        const excludedItemsLabel = this.buildExcludedItemLabel(type, excludedItemsNumber);

        let table;
        let footer;

        switch (type) {
            case TYPE_OTHERS:
                table = (
                    <BrokerMyInvestmentsProductsOthers
                        immStocks={productList}
                        showCompleteList={this.state.showCompleteList[type]}
                        isContractSection={this.props.isContractSection}
                        pageName={this.props.pageName}
                    />
                );
                footer = (
                    <div className="broker-my-investments-tables__link-wrapper clearfix">
                        <div className="pull-left">
                            <OKLink to={BROKER_CORPORATE_OPERATIONS_URL}>
                                <FormattedText className="broker-my-investments-tables__others-footer-text" value="broker-productCorporatesOperationsOthers" />
                            </OKLink>
                        </div>
                    </div>
                );
                break;

            case TYPE_STOCKS:
            case TYPE_WARRANTS:
            case TYPE_ETFS:
                table = (
                    <BrokerMyInvestmentsStocksTable
                        type={type}
                        immStocks={productList}
                        currency={currency}
                        showCompleteList={this.state.showCompleteList[type]}
                        isContractSection={this.props.isContractSection}
                        alternativeValueColumnTitle={alternativeValueColumnTitle}
                        onHandleBuyClick={this.props.onHandleBuyClick}
                        pageName={this.props.pageName}
                    />
                );
                break;

            case TYPE_PLANS:
            case TYPE_FUNDS:
                table = (
                    <BrokerMyInvestmentsFundsTable
                        type={type}
                        immStocks={productList}
                        immFundsContributionsList={immFundsContributionsList}
                        currency={currency}
                        showCompleteList={this.state.showCompleteList[type]}
                        alternativeValueColumnTitle={type === TYPE_FUNDS && alternativeValueColumnTitle}
                        pageName={this.props.pageName}
                    />
                );
                break;
            case TYPE_ALTERNATIVE_FUNDS_PG:
                table = (
                    <BrokerMyInvestmentsFundsTable
                        type={type}
                        immStocks={productList}
                        currency={currency}
                        showCompleteList={this.state.showCompleteList[type]}
                        alternativeValueColumnTitle={'alternativeFundsValueColumnTitle'}
                        onHandleBuyClick={this.props.onHandleBuyClick}
                        pageName={this.props.pageName}
                        immFundsContributionsList={immFundsContributionsList}
                    />
                );
                break;
            default:
                throw new Error("brokerMyInvestmentsProducts - Product type ${type} cannot be handled");
        }

        if (type !== TYPE_OTHERS) {
            footer = (
                <div className="broker-my-investments-tables__link-wrapper clearfix">
                    <div className="pull-left">
                        {seeAllLink}
                    </div>
                    <div className="pull-right">
                        {searchLink}
                    </div>
                </div>
            );
        }

        return (
            <BrokerMyInvestmentsWrappedProductsTable
                type={type}
                productType={title}
                itemsNumber={itemsNumber}
                currency={currency}
                earnings={earnings}
                earningsPercentage={earningsPercentage}
                total={totalValue}
                capital={capital}
                hasExcludedItems={hasExcludedItems}
                excludedItemsLabel={excludedItemsLabel}
                isContractSection={this.props.isContractSection}
                onOpenTraderClick={onOpenTraderClick}
                setOrdersAndMovementsAccessFrom={this.props.setOrdersAndMovementsAccessFrom}
                pageName={this.props.pageName}
            >
                {table}
                {footer}
            </BrokerMyInvestmentsWrappedProductsTable>
        );
    }

    renderProductsTable = () => {
        const { flagBasedFeatures, immStocksByType } = this.props;
        const checks = {
            [TYPE_STOCKS]: 'displayStocks',
            [TYPE_WARRANTS]: 'displayWarrants',
            [TYPE_ETFS]: 'displayETFs',
            [TYPE_FUNDS]: 'displayFunds',
            [TYPE_PLANS]: 'displayPlans',
            [TYPE_ALTERNATIVE_FUNDS_PG]: 'displayAlternativeFunds'
        }
        const ffShowAlternativeFundsTable = flagBasedFeatures.get(SHOW_GLOBAL_POSITION_VENTURE_CAPITAL_FUNDS);

        return flagBasedFeatures.get(INVESTMENT_PRODUCTS_LIST).map(product => {
          if (
            (product === TYPE_ALTERNATIVE_FUNDS_PG && ffShowAlternativeFundsTable) ||
            product !== TYPE_ALTERNATIVE_FUNDS_PG
          ) {
            return (
              this.props[checks[product]] &&
              this.wrapProductTable(
                product,
                immStocksByType.get(
                  product === TYPE_ALTERNATIVE_FUNDS_PG ? ALTERNATIVE_FUNDS : product
                )
              )
            );
          }
        });
    }

    render() {
        const {
            isFetchingStocksByType,
            totalInvestment,
            totalValue,
            totalEarnings,
            totalEarningsPercentage,
            displayFooter,
            immMyWalletCharts
        } = this.props;

        let footer;

        if (displayFooter) {
            const footerCurrency = 'EUR'; // @hardcoded
            footer = (
                <BrokerMyInvestmentsFooter
                    isContractFooter={false}
                    currency={footerCurrency}
                    totalCapital={totalInvestment}
                    totalRentability={totalEarnings}
                    totalRentabilityPercentage={totalEarningsPercentage}
                    totalValue={totalValue}
                    immMyWalletCharts={immMyWalletCharts}
                />
            );
        }

        if (isFetchingStocksByType) {
            return <LoadingSection />;
        } else {
            const investmentTableStyle = __CONTACT_CENTER__ ? { overflowX: 'auto' } : {}
            return (
                <div>
                    <div className="broker-my-investments-tables" style={investmentTableStyle}>
                        <div>
                            {this.renderProductsTable()}
                            {this.buildOthersTable()}
                            {footer}
                        </div>
                    </div>
                </div>
            );
        }
    }
}

BrokerMyInvestmentsProducts.propTypes = {
    flagBasedFeatures: PropTypes.object.isRequired,
    immStocksByType: PropTypes.object,
    isFetchingStocksByType: PropTypes.bool,
    isContractSection: PropTypes.bool,
    onHandleBuyClick: PropTypes.func,
    displayStocks: PropTypes.bool,
    displayWarrants: PropTypes.bool,
    displayETFs: PropTypes.bool,
    displayFunds: PropTypes.bool,
    displayAlternativeFunds: PropTypes.bool,
    displayPlans: PropTypes.bool,
    startExpanded: PropTypes.bool,
    totalInvestment: PropTypes.number,
    totalEarnings: PropTypes.number,
    totalEarningsPercentage: PropTypes.number,
    totalValue: PropTypes.number,
    alternativeValueColumnTitle: PropTypes.bool,
    displayFooter: PropTypes.bool,
    onOpenTraderClick: PropTypes.func.isRequired,
    setOrdersAndMovementsAccessFrom: PropTypes.func.isRequired,
    displayOthers: PropTypes.bool,
    immMyWalletCharts: PropTypes.object,
    resetSpecificProduct: PropTypes.func.isRequired,
    pageName: PropTypes.string
};

BrokerMyInvestmentsProducts.defaultProps = {
    immStocksByType: Immutable.Map(),
    isContractSection: false,
    displayStocks: true,
    displayWarrants: true,
    displayETFs: true,
    displayFunds: true,
    displayAlternativeFunds: true,
    displayPlans: true,
    alternativeValueColumnTitle: false,
    displayFooter: true,
    displayOthers: true
};

module.exports = withFeatureToggling(BrokerMyInvestmentsProducts);

